import { sendGAEvent } from '../../../domain/marketing/gtm-provider';
import { useEffect } from 'react';

const NoRecommendedItems = () => {

    useEffect(() => {
        sendGAEvent('My Recommended Products Page', 'No Products');
    }, []);

    return (
        <div className="w-full bg-gray-100 px-6 py-10">
            <p className="mb-4">
                <b className="text-lg"><span className="text-3xl">Sorry,</span> you currently have no personal recommendations.</b>
            </p>
            <div className="mb-4">
                <p>
                    This may be because you own no Waves products based on which we can make recommendations.
                </p>
                <p>
                    After you make your next purchase, please check back to see your personal recommendations.
                </p>
            </div>
            <div><a href="/specials" className="w-btn w-auto inline-block px-10">Shop Waves Specials</a></div>
        </div>
    );
};

export default NoRecommendedItems;